(async () => {
  const { debounce, parseHTML } = await import(window.theme.modules.utils);
  const baseComponent = await import(window.theme.modules.baseComponent);
  customElements.define('predictive-search-input', class extends baseComponent.default {
    elements = {input:'input[name="q"]',results:'[data-results]'};
    minChars = 3;
    render() {
      this.sources = this.getAttribute('sources').split(',').filter(Boolean);
      this.$input.setAttribute('autocomplete','off');
      this.$results.setAttribute('aria-live','polite');
      const request = debounce(() => this._getSearchResults(),300);
      this.$input.addEventListener('input',() => {
        this.controller?.abort();
        this.requestId = (this.requestId || 0) + 1;
        this.searchQuery = this.$input.value.trim();
        this._cleanResults();
        if(this.searchQuery.length >= this.minChars) request();
      });
    }
    async _getSearchResults() {
      const query=this.$input.value.trim(),id=this.requestId;
      if(query.length<this.minChars || !this.isConnected) return;
      this.controller?.abort();
      this.controller=new AbortController();
      const params=new URLSearchParams({q:query,'resources[type]':this.sources.join(','),'resources[limit]':this.getAttribute('results-limit'),section_id:'predictive-search'});
      if(this.hasAttribute('only-stock-products')) params.set('resources[options][unavailable_products]','hide');
      this.$results.setAttribute('aria-busy','true');
      try {
        const response=await fetch(window.theme.routes.predictiveSearch+'?'+params.toString(),{signal:this.controller.signal});
        if(!response.ok) throw new Error('Search unavailable');
        const text=await response.text();
        if(id!==this.requestId || query!==this.$input.value.trim()) return;
        const results=parseHTML(text).querySelector('#shopify-section-predictive-search');
        results ? this.$results.replaceChildren(results) : this._cleanResults();
      } catch(error) {
        if(id===this.requestId && error.name!=='AbortError' && this.isConnected) {
          const message=document.createElement('p');message.setAttribute('role','status');message.textContent='Suggestions could not load. Press Enter to search all results.';this.$results.replaceChildren(message);
        }
      } finally {
        if(id===this.requestId) this.$results.removeAttribute('aria-busy');
      }
    }
    _cleanResults(){this.$results.replaceChildren();this.$results.removeAttribute('aria-busy');}
    disconnectedCallback(){super.disconnectedCallback();this.controller?.abort();this.requestId=(this.requestId||0)+1;}
  });
})();

